import { render, staticRenderFns } from "./ShipperSelect.vue?vue&type=template&id=3c5134f2&scoped=true&"
import script from "./ShipperSelect.vue?vue&type=script&lang=js&"
export * from "./ShipperSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c5134f2",
  null
  
)

export default component.exports